<div class="tips-container">
  <div class="tips-header" (click)="toggleTips()">
    <gb-icon icon="lightbulb" class="tips-icon" [library]="IconLibrary.material"></gb-icon>
    <p class="tips-title" translate="BRANDING.GENERATE_LOGO_AND_BANNER.TIPS_TITLE"></p>
    <gb-icon
      [icon]="tipsExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
      class="expand-icon"
      [library]="IconLibrary.material"
    ></gb-icon>
  </div>
  <div class="tips-content" [class.expanded]="tipsExpanded">
    <ul>
      <li translate="BRANDING.GENERATE_LOGO_AND_BANNER.TIP_1"></li>
      <li translate="BRANDING.GENERATE_LOGO_AND_BANNER.TIP_2"></li>
      <li translate="BRANDING.GENERATE_LOGO_AND_BANNER.TIP_3"></li>
    </ul>
  </div>
</div>

<p class="ai-disclaimer">
  <span translate="BRANDING.GENERATE_LOGO_AND_BANNER.DISCLAIMER_GENERAL"></span>
  @if (showLogoDisclaimer) {
    <span translate="BRANDING.GENERATE_LOGO_AND_BANNER.DISCLAIMER_LOGO_BG"></span>
  }
</p>
